import React from "react";
import { Button, Icon } from "@mui/material";

type LocationsExpandCollapseButtonsProps = {
  expanded: string[];
  setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
  allLocationsIds: string[];
  disabled?: boolean;
};

function LocationsExpandCollapseButtons({
  expanded,
  setExpanded,
  allLocationsIds,
  disabled,
}: LocationsExpandCollapseButtonsProps) {
  return (
    <Button
      disabled={!allLocationsIds?.length || disabled}
      size="small"
      onClick={() =>
        setExpanded((p) =>
          p.length !== allLocationsIds.length ? [...allLocationsIds] : []
        )
      }
      variant={
        allLocationsIds.length === expanded.length ? "outlined" : "contained"
      }
      endIcon={
        <Icon>
          {allLocationsIds.length === expanded.length
            ? "expand_less"
            : "expand_more"}
        </Icon>
      }
      color="primary"
    >
      {allLocationsIds.length === expanded.length
        ? "Collapse All"
        : "Expand All"}
    </Button>
  );
}

export default LocationsExpandCollapseButtons;
